<template>
  <div
    :class="computedClasses('card')"
    class="mx-auto mb-8 transition duration-[1000ms] ease-in-out hover:border-yellow-500 hover:scale-105 hover:cursor-pointer"
  >
    <div class="grid place-items-center p-4">
      <span :class="computedClasses('title')">
        {{ title }}
      </span>
      <div class="bg-white bg-opacity-50 rounded p-2">
        <span :class="props.priceColor" class="text-2xl font-bold">
          ${{ price }} </span
        ><span class="text-slate-700"> / mo </span>
      </div>
    </div>
    <div :class="computedClasses('body')">
      <div
        v-for="bulletPoint in bulletPoints"
        :key="bulletPoint"
        :class="computedClasses('bullet')"
      >
        <span class="text-lg font-semibold">+ {{ bulletPoint }}</span>
      </div>
    </div>
    <div>
      <div
        class="border w-fit mx-auto p-4 mt-2 rounded-md hover:bg-green-600 font-bold min-w-[133px] text-center"
        @click="handleClick"
      >
        Buy Now
      </div>
      <div
        class="hidden border w-fit mx-auto p-4 mt-2 rounded-md hover:bg-yellow-600 font-bold min-w-[133px] text-center]"
        @click="router.push('/plandetails')"
      >
        Learn More...
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const props = defineProps({
  title: String,
  bulletPoints: Array,
  color: {
    type: String,
    default: "purple",
  },
  price: {
    type: Number,
    default: 0,
  },
  link: String,
  priceColor: {
    type: String,
    default: "text-slate-900",
  },
});

const colorClassMapping = {
  purple: {
    card: "bg-gradient-to-r from-purple-600 via-purple-700 to-purple-800 border-purple-900",
    title: "text-purple-100",
    body: "bg-gradient-to-r from-purple-500 via-purple-400 to-purple-300",
    bullet: "bg-gradient-to-r from-purple-300 via-purple-200 to-purple-100",
  },
  green: {
    card: "bg-gradient-to-r from-green-600 via-green-700 to-green-800 border-green-900",
    title: "text-green-100",
    body: "bg-gradient-to-r from-green-500 via-green-400 to-green-300",
    bullet: "bg-gradient-to-r from-green-300 via-green-200 to-green-100",
  },
  blue: {
    card: "bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 border-blue-900",
    title: "text-blue-100",
    body: "bg-gradient-to-r from-blue-500 via-blue-400 to-blue-300",
    bullet: "bg-gradient-to-r from-blue-300 via-blue-200 to-blue-100",
  },
};

const handleClick = () => {
  if (props.link) {
    // console.log("opening link", props.link);
    window.open(props.link, "_blank");
  }
};

const computedClasses = (type) => {
  const baseClasses = {
    card: "m-2 py-4 w-[300px] min-w-[300px] border-4 rounded-[20px] shadow-lg",
    title: "text-5xl font-bold my-4",
    body: "w-full",
    bullet: "text-slate-900 flex items-center py-2 pl-4",
  };

  return `${baseClasses[type]} ${colorClassMapping[props.color][type]}`;
};
</script>

<style scoped></style>
